function fetchRelatedProducts() {
  if ($('.recommended-products').length) {
    fetch(
      `/recommendations/products?product_id=${$('.recommended-products').attr('data-product-id')}&section_id=product-recommendations`
    )
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('.product-recommendations');
        document.querySelector('.recommended-products').innerHTML = recommendations.innerHTML;
        $('.recommended-products__section').fadeIn();
        var swiper = new Swiper('.recommended-products__section .slider-section__main .swiper', {
          draggable: true,
          slidesPerView: '1.2',
          spaceBetween: 10,
          grabCursor: true,
          freeMode: false,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          navigation: {
            nextEl: '.recommended-products__section .carousel__arrows .arrow--next',
            prevEl: '.recommended-products__section .carousel__arrows .arrow--prev',
          },
          mousewheel: {
            forceToAxis: true,
          },
          breakpoints: {
            600: {
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              slidesPerView: 2,
            },
            1024: {
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
              slidesPerView: 4,
            },
          },
        });
        window.updateProductCardsWishlist?.();
      })
      .catch(function (e) {
        console.error(e);
      });
  }
}

window.fetchRelatedProducts = fetchRelatedProducts;

document.addEventListener('DOMContentLoaded', function () {
  fetchRelatedProducts();
  $('.product-section-block__btn').on('click', function () {
    $(window).scrollTop(0);
  });
});
